/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, TextField, Typography, Paper } from "@mui/material";
import { styled } from "@mui/system";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";

// Styled components
const Container = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  background: "linear-gradient(to right, #6a11cb, #2575fc)",
});

const LoginCard = styled(Paper)({
  padding: "40px 30px",
  maxWidth: 400,
  width: "100%",
  textAlign: "center",
  borderRadius: 16,
  boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
});

const ErrorText = styled(Typography)({
  color: "red",
  marginTop: 10,
});

// Validation schema
const PhoneSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, "Enter a valid 10-digit phone number")
    .required("Phone number is required"),
});

const PhoneLogin = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const handleNext = async (values, { setSubmitting }) => {
    setError("");
    try {
      const res = await axios.post(
        "https://api.cansunsari.org.np/dspro/api/auth/login",
        { phoneNumber: values.phoneNumber },
        { headers: { "Content-Type": "application/json" } },
      );

      localStorage.setItem("phoneNumber", values.phoneNumber);
      localStorage.setItem("loginSessionId", res.data.sessionId || "");

      navigate("/otp-verification");
    } catch (err) {
      console.error(err);
      setError("Failed to send OTP. Please check the phone number.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container>
      <LoginCard>
        <Typography variant="h4" gutterBottom>
          Login with Phone
        </Typography>

        <Formik
          initialValues={{ phoneNumber: "" }}
          validationSchema={PhoneSchema}
          onSubmit={handleNext}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            isSubmitting,
          }) => (
            <Form>
              <TextField
                fullWidth
                id="phoneNumber"
                name="phoneNumber"
                label="Phone Number"
                placeholder="##########"
                value={values.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.phoneNumber && Boolean(errors.phoneNumber)}
                helperText={touched.phoneNumber && errors.phoneNumber}
                margin="normal"
              />

              {error && <ErrorText>{error}</ErrorText>}

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2, py: 1.5 }}
                disabled={isSubmitting}
              >
                Send OTP
              </Button>
            </Form>
          )}
        </Formik>
      </LoginCard>
    </Container>
  );
};

export default PhoneLogin;
